<label [class.required]="field.required">
  <div [ngStyle]="{ width: field.width + 'px', height: field.height + 'px' }">
    <img [src]="field.value" alt="" (click)="toggleCheckbox()" [ngStyle]="fieldStyle" />
  </div>
</label>
